<template>
    <div class="container vehicle-details">
        <div class="vehicle-details__grid">
            <div class="vehicle-details__breadcrumbs">
                <router-link :to="lastSearchPage" class="link link--secondary link--has-icon-reverse">Back<span
                        class="hidden__xs">&nbsp;To Search</span></router-link>

                <auto-trader-value-rating v-if="vehicle" class="search-results-vehicle__at-rating-container"
                    :rating="vehicle.value_rating"
                    :classes="{ 'at-lg-value-img': true, 'hidden-xs': true }"></auto-trader-value-rating>
            </div>

            <div class="vehicle-details__gallery">
                <slot name="gallery"></slot>
            </div>

            <div class="vehicle-details__info">
                <div class="rd-card rd-card--border-top">
                    <div class="vehicle-details__card-action-bar">
                        <div class="vehicle-details__action-tab">
                            <input type="checkbox" value="" class="save-to-compare" :id="'compare-' + vehicle.id"
                                name="save-to-compare" @click="saveVehicle" />
                            <label :for="'compare-' + vehicle.id">
                                <div class="vehicle-details__action-section">
                                    <svg :class="{ 'vehicle-details__save-vehicle-icon': true, 'vehicle-details__save-vehicle-icon--active': accountVehicleActions.vehicleSaved }"
                                        width="32" height="29" viewBox="0 0 32 29" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M31 9.2C31 4.7 27.4 1.1 22.9 1.1 20 1.1 17.4 2.7 16 5 14.6 2.7 12 1.1 9.1 1.1 4.6 1.1 1 4.7 1 9.2 1 11.6 2.1 13.8 3.8 15.3L15.3 26.8C15.5 27 15.7 27.1 16 27.1 16.3 27.1 16.5 27 16.7 26.8L28.2 15.3C29.9 13.8 31 11.6 31 9.2Z" />
                                    </svg>
                                    <p>Save</p>
                                </div>
                            </label>
                        </div>
                        <div class="vehicle-details__action-tab">
                            <input type="checkbox" value="" class="price-alert" :id="'price-alert-' + vehicle.id"
                                name="price-alert" @click="priceAlertModal" />
                            <label :for="'price-alert-' + vehicle.id">
                                <div class="vehicle-details__action-section">
                                    <svg :class="{ 'vehicle-details__price-alert-icon': true, 'vehicle-details__price-alert-icon--active': accountVehicleActions.priceAlert}"
                                        width="17" height="17.5" fill="none" version="1.1" viewBox="0 0 17 17.5"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="m5.8028 13.944c0.41421 0 0.75-0.3357 0.75-0.75 0-0.4142-0.33579-0.75-0.75-0.75zm-4.8716-0.8368-0.44201 0.6059 1.09e-4 1e-4zm-0.18096-0.3188-0.74708 0.0661h5e-6zm1.0278-1.8285 0.63786 0.3945h2e-5zm2.9054-8.7524-0.50847-0.55132v1e-5zm7.6327 0-0.5084 0.55132v2e-5zm2.9055 8.7524 0.6379-0.3945zm1.0279 1.8285 0.747 0.0661v-2e-4zm-0.181 0.3188 0.4419 0.606 1e-4 -1e-4zm-4.8701-0.6632c-0.4142 0-0.75 0.3358-0.75 0.75 0 0.4143 0.3358 0.75 0.75 0.75zm-4.6457 0.7513c6.8e-4 -0.4142-0.33455-0.7506-0.74876-0.7513-0.41421-6e-4 -0.75056 0.3346-0.75124 0.7488zm-0.75148 0.8876-0.75-0.0012v0.0012zm6.1472-0.8889c0-0.4142-0.3358-0.75-0.75-0.75s-0.75 0.3358-0.75 0.75zm-6.1457-0.75c-0.41422 0-0.75 0.3358-0.75 0.75 0 0.4143 0.33578 0.75 0.75 0.75zm5.3957 1.5c0.4142 0 0.75-0.3357 0.75-0.75 0-0.4142-0.3358-0.75-0.75-0.75zm-5.3957-1.5h-3.0545v1.5h3.0545zm-3.0545 0c-0.57264 0-0.98028-1e-4 -1.2611-0.0103-0.14145-0.0052-0.22834-0.0123-0.27736-0.0191-0.02433-0.0034-0.02331-0.0046-0.00674 9.9e-5 0.00765 0.0022 0.08214 0.0225 0.16999 0.0865l-0.88381 1.212c0.11762 0.0858 0.23585 0.125 0.30167 0.1438 0.07474 0.0214 0.14836 0.0344 0.21153 0.0432 0.12597 0.0176 0.27366 0.0268 0.43009 0.0325 0.31499 0.0115 0.75634 0.0113 1.3157 0.0113zm-1.3751 0.0573c-0.04446-0.0324 0.02075 0.0054 0.07503 0.101 0.05472 0.0965 0.05375 0.1728 0.04906 0.1199l-1.4941 0.1323c0.009804 0.1107 0.032425 0.2977 0.14056 0.4882 0.1077 0.1898 0.25614 0.3052 0.34547 0.3704zm0.1241 0.221c0.00629 0.0711-4e-4 0.1257-0.0049 0.1535-0.00482 0.0298-0.01066 0.0499-0.01285 0.0571-0.00393 0.0129-0.00354 0.0082 0.01-0.0213 0.02681-0.0585 0.07677-0.1534 0.15965-0.2974 0.16438-0.2857 0.41671-0.6939 0.76669-1.2598l-1.2757-0.789c-0.34384 0.5559-0.61186 0.9891-0.79115 1.3007-0.088962 0.1547-0.16668 0.2975-0.22296 0.4202-0.028011 0.0611-0.058028 0.1329-0.081174 0.2087-0.018618 0.061-0.056189 0.1964-0.041761 0.3595zm0.91861-1.3679c0.79209-1.2808 1.4367-3.1047 1.4367-5.627h-1.5c0 2.2531-0.5719 3.8022-1.2125 4.838zm1.4367-5.627c0-1.1008 0.47358-2.1701 1.3393-2.9685l-1.017-1.1026c-1.1586 1.0686-1.8223 2.5316-1.8223 4.0711zm1.3393-2.9685c0.86773-0.8003 2.0567-1.2593 3.3079-1.2593v-1.5c-1.6116 0-3.1683 0.58991-4.3249 1.6566zm3.3079-1.2593c1.2512 0 2.4402 0.45898 3.3079 1.2593l1.0169-1.1026c-1.1566-1.0667-2.7132-1.6566-4.3248-1.6566zm3.3079 1.2593c0.8657 0.79841 1.3393 1.8677 1.3393 2.9685h1.5c0-1.5396-0.6636-3.0025-1.8224-4.0712zm1.3393 2.9685c0 2.5224 0.6446 4.3462 1.4368 5.627l1.2757-0.789c-0.6406-1.0358-1.2125-2.5849-1.2125-4.838zm1.4368 5.627c0.3499 0.5659 0.6022 0.9741 0.7666 1.2598 0.0829 0.1441 0.1329 0.2389 0.1597 0.2974 0.0136 0.0295 0.014 0.0343 0.01 0.0214-0.0022-0.0072-8e-3 -0.0273-0.0128-0.0571-0.0045-0.0278-0.0112-0.0824-0.0049-0.1535l1.4941 0.1319c0.0144-0.163-0.0231-0.2984-0.0418-0.3594-0.0231-0.0758-0.0531-0.1475-0.0811-0.2086-0.0563-0.1227-0.134-0.2655-0.223-0.4202-0.1793-0.3116-0.4473-0.7448-0.7911-1.3007zm0.9186 1.3678c-0.0047 0.0528-0.0057-0.0235 0.0491-0.12 0.0542-0.0955 0.1194-0.1333 0.0749-0.1009l0.8841 1.2118c0.0893-0.0652 0.2377-0.1806 0.3454-0.3703 0.1082-0.1905 0.1308-0.3775 0.1406-0.4883zm0.1242-0.221c0.0878-0.0641 0.1623-0.0843 0.17-0.0865 0.0165-0.0047 0.0175-0.0035-0.0068-9.9e-5 -0.049 0.0068-0.1359 0.0139-0.2773 0.0191-0.2808 0.0102-0.6885 0.0103-1.2611 0.0103v1.5c0.5594 0 1.0007 2e-4 1.3157-0.0113 0.1564-0.0057 0.3041-0.0149 0.4301-0.0325 0.0631-0.0088 0.1368-0.0218 0.2115-0.0432 0.0658-0.0188 0.184-0.058 0.3017-0.1438zm-1.3752-0.0572h-3.053v1.5h3.053zm-9.1987 0.7488-0.00148 0.8889 1.5 0.0025 0.00148-0.8889zm-0.00148 0.8901c0 1.8955 1.5525 3.4167 3.4486 3.4167v-1.5c-1.0846 0-1.9486-0.8665-1.9486-1.9167zm3.4486 3.4167c1.8962 0 3.4486-1.5213 3.4486-3.4167h-1.5c0 1.0502-0.86395 1.9167-1.9486 1.9167zm3.4486-3.4167v-0.8889h-1.5v0.8889zm-6.1457-0.1389h5.3957v-1.5h-5.3957z"
                                            fill="#0293d6" />
                                    </svg>
                                    <p>Price Alert</p>
                                </div>
                            </label>
                        </div>
                    </div>


                    <div class="vehicle-details__vehicle-details">
                        <div class="vehicle-details__title">
                            <h2 class="h2">{{ vehicle.manufacturer }} {{ vehicle.model }}</h2>
                            <h5 class="vehicle-details__version">{{ vehicle.body }} {{ vehicle.version }}</h5>
                        </div>
                    </div>

                    <h6 class="vehicle-details__vehicle-location" v-if="!vehicle.location.is_national_centre">
                        <button
                            v-on:click="() => {customEvent(customEventCategory, 'Clicked', 'Dealer Name Link'); openDealerModal()}"
                            class="vehicle-details__vehicle-location--with-icon vehicle-details__vehicle-location--link">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                                class="vehicle-details__vehicle-location-icon">
                                <path fill-rule="evenodd"
                                    d="M11.54 22.351l.07.04.028.016a.76.76 0 00.723 0l.028-.015.071-.041a16.975 16.975 0 001.144-.742 19.58 19.58 0 002.683-2.282c1.944-1.99 3.963-4.98 3.963-8.827a8.25 8.25 0 00-16.5 0c0 3.846 2.02 6.837 3.963 8.827a19.58 19.58 0 002.682 2.282 16.975 16.975 0 001.145.742zM12 13.5a3 3 0 100-6 3 3 0 000 6z"
                                    clip-rule="evenodd" />
                            </svg>
                            <span>{{ dealerName }}</span>
                        </button>
                    </h6>
                    <h6 class="vehicle-details__vehicle-location" v-else><a href="/online-store"
                            class="link link--secondary">{{ dealerName }}</a></h6>

                    <div class="vehicle-details__vehicle-price">
                        <div class="vehicle-details__vehicle-price-purchase">
                            <span>Vehicle Price from</span>
                            <div>
                                <span class="vehicle-details__vehicle-price-purchase--price">
                                    &pound;{{ vehicle.price_formatted }}
                                </span>
                            </div>
                            <template v-if="vehicle.vat_type == 'vat'">
                                <span class="">+VAT</span>
                            </template>
                        </div>
                        <template v-if="!isReserved && haveFinance">
                            <template v-if="monthlyPrice == 'loading'">
                                <div
                                    class="vehicle-details__vehicle-price-finance vehicle-details__vehicle-price-finance--loading">
                                    <img class="vehicle-details__vehicle-price-finance--loader"
                                        src="/images/shared/Robins-And-Day-Loader.svg" alt="Loading Results" />
                                </div>
                            </template>
                            <template v-else-if="!monthlyPrice">
                                <div class="vehicle-details__vehicle-price-finance"
                                    @click="() => {customEvent(customEventCategory, 'Clicked', 'Ask About Price'); $emit('scroll-finance')}">
                                    Ask about
                                    finance</div>
                            </template>

                            <div v-else class="vehicle-details__vehicle-price-finance"
                                @click="() => {customEvent(customEventCategory, 'Clicked', 'Monthly Price'); $emit('scroll-finance')}">
                                <span>Per Month from*</span>
                                <div>
                                    <span class="vehicle-details__vehicle-price-finance--price"
                                        v-html="monthlyPrice"></span>
                                </div>
                            </div>

                            <div v-if="aprRate" class="vehicle-details__vehicle-price-finance"
                                @click="() => $emit('scroll-finance')">
                                <span>APR Rate</span>
                                <div>
                                    <span class="vehicle-details__vehicle-price-finance--price"
                                        v-html="aprRate"></span>
                                </div>
                            </div>

                            <div v-if="depositContribution" class="vehicle-details__vehicle-price-finance"
                                @click="() => $emit('scroll-finance')">
                                <span>Deposit Contribution</span>
                                <div>
                                    <span class="vehicle-details__vehicle-price-finance--price"
                                        v-html="depositContribution"></span>
                                </div>
                            </div>
                        </template>

                        <div v-if="!stockSearch && !vehicle.location.is_national_centre && !isReserved"
                            class="vehicle-details__test-drive">
                            <button v-on:click="bookATestDrive" class="vehicle-details__link-btn link link--is-button link--has-icon">
                                Book A Test Drive
                            </button>
                        </div>
                        <div v-else-if="stockSearch && !vehicle.location.is_national_centre && !isReserved"
                            class="vehicle-details__test-drive">
                            <button v-on:click="enquireNow" class="vehicle-details__link-btn link link--is-button link--has-icon">
                                Enquire Now
                            </button>
                        </div>

                        <div class="vehicle-details__personalise-finance" v-if="!isReserved">
                            <button class="vehicle-details__link-btn link link--secondary link--is-button link--has-icon"
                                @click="() => {customEvent(customEventCategory, 'Clicked', 'Personalise Finance Link'); $emit('scroll-finance')}">Personalise
                                Finance</button>
                        </div>
                    </div>


                    <div class="vehicle-details__button-group">
                        <button v-if="(stockSearch == false) && !(buyOnlineDisabled && reserveOnlineDisabled)"
                            @click="navigateToBuyOnline" class="btn btn--primary btn--full-width"
                            :disabled="buyOnlineDisabled">
                            <template v-if="!buyOnlineDisabled">Buy Online</template>
                            <template v-else-if="isSold">Vehicle Sold</template>
                            <template v-else>Vehicle Reserved</template>
                        </button>

                        <button type="button"
                            :class="{ 'btn btn--full-width': true, 'vehicle-details__btn-reserve-online': !stockSearch, 'btn--primary': stockSearch }"
                            @click="navigateToReserveOnline()" :disabled="reserveOnlineDisabled">
                            <template v-if="reserveOnlineDisabled"> Vehicle Reserved </template>
                            <template v-else> Reserve Online </template>
                        </button>

                        <button v-if="isReserved" @click="showEnquiryForm()" class="btn btn--full-width btn--primary"> Make
                            an enquiry </button>
                    </div>

                    <template v-if="vehicle.location">
                        <div v-if="isReserved"
                            class="vehicle-details__btn-container--m-t vehicle-details__btn-container--m-b">
                            <button v-on:click="showSimilarStock()"
                                class="link link--secondary link--is-button link--has-icon">
                                View Similar Stock
                            </button>
                        </div>

                        <modal v-if="dealerModalData" :open="isDealerModalOpen" :narrow="false" :borderTop="false"
                            @close="closeDealerModal" :show-close-icon="true">
                            <template v-slot:image>
                                <picture v-if="dealerModalData.image.length > 0">
                                    <source :srcset="`${dealerModalData.image}.webp, ${dealerModalData.image}@2x.webp 2x`"
                                        type="image/webp" />
                                    <img class="vehicle-details__vehicle-location-model-image"
                                        :srcset="`${dealerModalData.image}.jpg, ${dealerModalData.image}@2x.jpg 2x`"
                                        :alt="dealerName" />
                                </picture>

                                <picture v-else>
                                    <img class="vehicle-details__vehicle-location-model-image"
                                        src="/images/dealers/image-coming-soon.jpg" alt="Photo coming soon" />
                                </picture>
                            </template>

                            <template v-slot:header>
                                <div class="vehicle-details__vehicle-location-model-heading">{{ dealerName }}</div>
                            </template>

                            <template v-slot:body>
                                <div class="vehicle-details__vehicle-location vehicle-details__vehicle-location-model">
                                    <a class="vehicle-details__vehicle-location-model-tel" :href="`tel:${tel}`">{{ tel
                                        }}</a>
                                    <div>
                                        <span>{{ vehicle.location.address }}, {{ vehicle.location.town }}, {{
                                            vehicle.location.postcode }}</span>
                                    </div>
                                    <div :class="{
                                        'vehicle-details__model-opening-hours': true,
                                        'vehicle-details__model-opening-hours--is-open': dealerModalData.isOpenWithTime.startsWith('<span>Open</span>'),
                                        'vehicle-details__model-opening-hours--is-closed': !dealerModalData.isOpenWithTime.startsWith('<span>Open</span>')
                                    }" v-html="dealerModalData.isOpenWithTime"></div>
                                    <button type="button" class="btn btn--primary btn--full-width" @click="enquireNow">
                                        Enquire Now
                                    </button>
                                </div>
                            </template>
                        </modal>
                    </template>

                    <div class="vehicle-details__key-specification-wrapper">
                        <span class="vehicle-details__key-specification-title">Key Specification</span>

                        <ul class="vehicle-details__key-specification">
                            <KeySpecItem svg="#svg-vehicle-type-default" label="Bodystyle" :value="vehicle.body" />

                            <KeySpecItem svg="#svg-transmission" label="Transmission" :value="vehicle.transmission" />

                            <KeySpecItem v-if="isElectric" svg="#svg-fuel-electric" label="Fuel Type"
                                :value="vehicle.fuel_type" />

                            <KeySpecItem v-else svg="#svg-fuel-ice" label="Fuel Type" :value="vehicle.fuel_type" />

                            <KeySpecItem v-if="isElectric && vehicle.battery_range_miles" svg="#svg-range-electric" label="Battery Range"
                                :value="`${vehicle.battery_range_miles} miles`" />

                            <template v-else>
                                <KeySpecItem svg="#svg-co2" label="CO2 Emissions" :value="co2Emissions" />

                                <KeySpecItem svg="#svg-range-ice" label="Miles Per Gallon"
                                    :value="`${Math.round(Number(vehicle.vehicle_mpg))} miles`" />
                            </template>

                            <KeySpecItem v-if="stockSearch == false" svg="#svg-registration" label="Registration"
                                :value="vehicle.reg_no" />

                            <KeySpecItem v-if="stockSearch == false" svg="#svg-mileage" label="Mileage"
                                :value="vehicleMilage" />

                            <KeySpecItem v-if="stockSearch == false && formattedWarranty" svg="#svg-warranty-icon-2" label="Used Car Warranty"
                                :value="formattedWarranty" />

                            <KeySpecItem v-if="formattedBatteryWarranty" svg="#svg-electric-range" label="Battery Warranty"
                                :value="formattedBatteryWarranty" />

                            <button v-if="vehicle.used_vehicle_features.length > 0"
                                class="link link--is-button link--has-icon vehicle-details__key-specification-link"
                                @click="() => {customEvent(customEventCategory, 'Clicked', 'View All');$emit('scroll')}">
                                View Specification
                            </button>

                            <button v-if="isElectric"
                                class="link link--is-button link--has-icon vehicle-details__key-specification-link"
                                @click="() => {customEvent('Used Vehicles - More Details', 'Clicked', 'Charging Information CTA');$emit('scroll-ev-calculator')}">
                                View Charging Information
                            </button>
                        </ul>
                    </div>

                    <div v-if="!stockSearch && hasLifetimeWarranty" class="vehicle-details__btn-container--m-t">
                        <button v-on:click="showCarePlan" class="link link--secondary link--is-button link--has-icon">
                            Available With Lifetime Warranty
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <price-alert-modal v-if="accountVehicleActions.displayPriceAlertModal" :vehicleData="vehicle"
            :priceAlert="accountVehicleActions.priceAlert" :open="accountVehicleActions.displayPriceAlertModal"
            v-on:alert-updated="priceAlertUpdated" :inMyAccountArea="false"></price-alert-modal>
        <login-modal v-if="loginModal.show == true"></login-modal>
        <saved-vehicle-modal :last-search-page="lastSearchPage"
            v-else-if="showSavedVehicleModal == 1"></saved-vehicle-modal>
    </div>
</template>

<script>

import { mapState, mapGetters } from "vuex";
import AutoTraderValueRating from "./AutoTraderValueRating";
import KeySpecItem from "./KeySpecItem.vue";
import Modal from "../../core/components/Modal.vue";
import PriceAlertModal from "../../my-account/components/price-alerts/PriceAlertModal.vue"
import { customEvent } from "../../modules/tracking/AnalyticsEvents";
import NumberFormat from '../api/NumberFormat';
import LoginModal from "../components/LoginModal.vue";
import SavedVehicleModal from "../components/SavedVehicleModal.vue";
import FormatWarranty from "../api/FormatWarranty";


export default {
    components: {
        AutoTraderValueRating,
        KeySpecItem,
        Modal,
        PriceAlertModal,
        LoginModal,
        SavedVehicleModal
    },
    props: {
        'vehicle': {
            type: Object,
            required: true
        },
        'monthlyPrice': {
            required: true
        },
        'aprRate': {
            required: true
        },
        'depositContribution': {
            required: true
        },
        'dealerName': {
            type: String,
            required: true
        },
        'tel': {
            type: String,
            required: true
        },
        'openingHours': {
            type: Object,
            required: true
        },
        'hasLiveChat': {
            type: Boolean,
            required: true
        },
        'isSold': {
            type: Boolean,
            required: true
        },
        'isReserved': {
            type: Boolean,
            required: false,
            default: false,
        },
        'buyOnlineDisabled': {
            type: Boolean,
            required: true
        },
        'reserveOnlineDisabled': {
            type: Boolean,
            required: true
        },
        'stockSearch': {
            type: Boolean,
            required: false,
            default: false,
        },
        'customEventCategory': {
            type: String,
            required: true,
        },
        'haveFinance': {
            type: Boolean,
            default: true,
        }
    },
    computed: {
        ...mapState("Auth", [
            'authenticated',
            'loginModal'
        ]),
        ...mapState("Layout", [
            'showSavedVehicleModal',
            'accountVehicleActions',
        ]),
        ...mapGetters({
            accountVehicleActions: 'Layout/accountActions',
        }),
        lastSearchPage() {
            if (this.$store.state.UsedSearchOptions.lastResultsUrl == false) {
                return {
                    name: "used-landing",
                };
            }
            return {
                name: this.$store.state.UsedSearchOptions.lastResultsUrl.name,
                params: this.$store.state.UsedSearchOptions.lastResultsUrl.params,
                query: this.$store.state.UsedSearchOptions.lastResultsUrl.query,
            };
        },
        vehicleMilage() {
            return Number(this.vehicle.mileage).toLocaleString('en-GB', { maximumFractionDigits: 0 });
        },
        isElectric() {
            return this.vehicle.fuel_type == 'Electric';
        },
        co2Emissions() {
            if (this.vehicle_co2 == null || this.vehicle_co2 <= 0) {
                return '0 g/km';
            }

            return NumberFormat(this.vehicle_co2, 0) + ' g/km';
        },
        address() {
            const address = [];
            if (this.vehicle.location) {
                if (this.vehicle.location.address) {
                    address.push(this.vehicle.location.address);
                }
                if (this.vehicle.location.town) {
                    address.push(this.vehicle.location.town);
                }
                if (this.vehicle.location.postcode) {
                    address.push(this.vehicle.location.postcode);
                }
            }
            return address.join(", ");
        },
        hasLifetimeWarranty() {
            if (this.vehicle.age < 2) {
                return false;
            }
            if (this.vehicle.age > 10) {
                return false;
            }
            if (this.vehicle.mileage > 100000) {
                return false;
            }
            return true;
        },
        formattedWarranty() {
            return FormatWarranty(Math.max(this.vehicle.manufacturer_warranty_months, this.vehicle.warranty_months), '');
        },
        formattedBatteryWarranty() {
            return FormatWarranty(this.vehicle.battery_warranty_months, '');
        }
    },
    data() {
        return {
            isDealerModalOpen: false,
            dealerModalData: null,
            priceAlert: null,
        }
    },
    methods: {
        openDealerModal() {
            this.isDealerModalOpen = true;

            if (this.dealerModalData != null) {
                return;
            }

            window.axios.post(`/ajax/used-vehicles/dealer-modal/${this.vehicle.location.id}`)
                .then(response => {
                    this.dealerModalData = response.data;
                })
                .catch(error => {
                    console.error(error);
                });
        },
        closeDealerModal() {
            this.isDealerModalOpen = false;
        },
        bookATestDrive() {
            this.$emit('book-a-test-drive');
            customEvent("Used Vehicles - More Details", "Clicked", "Book A Test Drive CTA");
        },
        enquireNow() {
            this.$emit('show-contact');
            this.closeDealerModal();
        },
        showCarePlan() {
            this.gaTag('Used Vehicles - More Details', 'Clicked', 'Lifetime Warranty CTA');
            this.$emit('show-care-plan');
            this.closeDealerModal();
        },
        navigateToBuyOnline() {
            if (this.buyOnlineDisabled) {
                console.error("Cannot buy vehicle online");
                return;
            }
            customEvent(this.customEventCategory, 'Clicked', 'Buy Online CTA');
            this.$router.push({ name: 'buy-online-landing', params: { id: this.vehicle.id } });
        },
        navigateToReserveOnline() {
            if (this.reserveOnlineDisabled) {
                console.error("Cannot reserve vehicle");
                return;
            }

            customEvent(this.customEventCategory, 'Clicked', 'Reserve Online CTA');
            this.$router.push({ name: 'reserve-online-landing', params: { id: this.vehicle.id } });
        },
        showEnquiryForm() {
            customEvent(this.customEventCategory, 'Clicked', 'Make an Enquiry CTA');
            this.$emit('show-enquiry-form');
        },
        showSimilarStock() {
            customEvent(this.customEventCategory, 'Clicked', 'View Similar Stock CTA');
            this.$emit('show-similar-stock');
        },
        customEvent,
        priceAlertModal() {
            customEvent('Used Cars - Price Alert', 'Clicked', 'Used Car More Details Page Icon');
            if (this.authenticated) {
                this.$store.commit('Layout/setShowPriceAlertModal', true, { root: true })
            } else {
                let vehicle = {
                    type: 'price-alert',
                    id: this.vehicle.id,
                }
                this.$store.commit('Layout/setSavePriceAlertAfterRegister', vehicle, { root: true })
                this.$store.commit('Auth/setPriceAlertUnauthenticated', true, { root: true })
                this.$store.commit('Auth/setShowLoginModal', {
                    show: true,
                    type: 'price-alert',
                },
                    { root: true })
            }
        },
        priceAlertUpdated(response) {
            if (response.hasOwnProperty('deleted')) {
                this.$store.commit('Layout/setShowPriceAlertModal', false, { root: true })
            }
            this.$store.dispatch('Layout/checkVehicleAccountActions', { vehicleId: this.vehicle.id, type: 'used' });
        },
        saveVehicle() {
            const add = !this.accountVehicleActions.vehicleSaved;
            this.$store.dispatch("Layout/saveVehicle", {
                type: "used",
                id: this.vehicle.id,
                add: add,
            }).catch(error => {
                console.error("Error saving vehicle: ", error);
            });
        }
    },
    beforeCreate() {
        if (!this.$store.hasModule('Auth')) {
            this.$store.registerModule('Auth', require('../../core/modules/Auth/auth').default);
        }
    },

    created() {
        this.$store.dispatch('Auth/checkAuthenticated');
        if (this.vehicle.id) {
            this.$store.dispatch('Layout/checkVehicleAccountActions', { vehicleId: this.vehicle.id, type: 'used' });
        }
    }
}
</script>

<style lang="scss">
@import "../../../sass/redesign/variables";

.vehicle-details {
    margin-top: 15px;
    margin-bottom: 30px;

    &__grid {
        display: grid;
        grid-template-columns: minmax(0, 1fr);
        gap: 30px;

        @media (min-width: $screen-md) {
            grid-template-rows: 37px 1fr;
            grid-template-columns: minmax(0, 1fr) 425px;
        }
    }

    &__breadcrumbs {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: space-between;
        align-items: center;

        @media (min-width: $screen-md) {
            grid-column: 1/2;
            grid-row: 1/2;
        }
    }

    &__gallery {
        @media (min-width: $screen-md) {
            grid-column: 1/2;
            grid-row: 2/3;
        }
    }

    &__info {
        @media (min-width: $screen-md) {
            grid-column: 2/3;
            grid-row: 1/3;
        }
    }

    &__vehicle-details {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        gap: 15px;
    }

    &__version {
        font-size: 16px;
        font-weight: 400;
        margin-top: 10px;
        margin-bottom: 0;
        line-height: 1.2;
    }

    &__card-action-bar {
        display: flex;
        justify-content: space-between;
        position: relative;
        margin-top: -28px;
        margin-bottom: 5px;
        // background-image: url(/images/events/2024/motab-electric-cashback/motab-bg@2x.webp);
        // background-repeat: no-repeat;
        // color: white;
        // border-radius: 10px 10px 0 0;
    }

    &__action-section {
        display: flex;
        justify-content: center;
        align-items: center;
        // border-radius: $default-card-border-radius;
        gap: 15px;
        cursor: pointer;
    }

    &__action-tab {
        input {
            display: none;
        }
    }

    &__save-vehicle {
        input {
            display: none;
        }
    }

    &__save-vehicle-button {
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: $default-card-border-radius;
        padding: 15px;
        cursor: pointer;

        &--background {
            background-color: HSLA(199, 98%, 42%, 0.1);
        }
    }

    &__save-vehicle-icon {
        stroke: $blue;
        stroke-width: 3px;
        fill: #ffffff;
        height: 20px;
        width: 20px;
        transition: fill 0.2s ease-in-out;

        &--active {
            fill: $blue;
        }
    }

    &__price-alert-icon {
        // stroke: $blue;
        fill: $blue;
        height: 20px;
        width: 20px;
        transition: fill 0.2s ease-in-out;

        &--active {
            fill: $blue;
            // stroke: $blue;
            // stroke-width: 1px;
        }
    }

    &__vehicle-price {
        border-top: 0.5px solid rgba(151, 151, 151, 0.5);
        display: grid;
        grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
        margin-top: 10px;
        padding-top: 10px;
        margin-bottom: 10px;
        gap: 10px;
    }

    &__vehicle-price-purchase {
        display: flex;
        flex-direction: column;
        font-size: 14px;
        flex-grow: 1;
        gap: 5px;

        &--price {
            font-size: 20px;
            font-weight: 700;
            color: $orange-price;
        }
    }

    &__vehicle-price-finance {
        display: flex;
        flex-direction: column;
        font-size: 14px;
        flex-grow: 1;
        gap: 5px;

        &--price {
            font-size: 20px;
            font-weight: 700;
            color: $blue-price;
            cursor: pointer;

            &:hover {
                text-decoration: underline;
                text-decoration-color: $blue-price;
                text-underline-offset: 4px;
                text-decoration-thickness: 3px;
            }
        }

        &--loading {
            justify-content: center;
            align-items: center;
        }

        &--loader {
            max-height: 40px;
        }
    }

    &__vehicle-price-hr {
        grid-row: 1/2;
        grid-column: 1/3;
        border: none;
        border-top: 0.5px solid rgba(151, 151, 151, 0.5);
        background: none;
        width: 100%;
    }

    &__test-drive {
        grid-column: 1/2;
    }

    &__personalise-finance {
        grid-column: 2/3;
    }

    &__link-btn {
        text-align: left;
        @media (max-width: 767px) {
            font-size: 14px;
        }
    }

    &__button-group {
        display: flex;
        flex-direction: column;
        gap: 15px;
    }

    &__btn-reserve-online {
        color: #ffffff;
        background-color: $blue-price;

        &:hover {
            // need actual colour instead of filter
            transition: filter 0.3s ease-in-out;
            filter: brightness(90%);
        }
    }

    &__vehicle-location {
        font-size: 16px;
        margin-top: 15px;

        &--link {
            color: $blue-price;
            appearance: none;
            border: none;
            background-color: transparent;
            padding: 0;
            font-weight: 700;
            cursor: pointer;

            &:visited {
                color: $blue-price;
            }
        }

        &--with-icon {
            display: flex;
            justify-content: start;
            align-items: center;
            gap: 10px;

        }

        &-icon {
            fill: $blue-price;
            height: 20px;
            width: 20px;
            align-self: flex-start;
            flex-shrink: 0;
            margin-left: -3px;
        }

        &-model {
            display: flex;
            flex-direction: column;
            gap: 10px;

            &-image {
                max-width: 350px;
            }

            &-heading {
                color: $dark-blue;
                font-size: 20px;
                font-weight: 700;

            }

            &-tel {
                color: $primary;
                font-size: 16px;
                font-weight: 700;
            }
        }
    }

    &__btn-container {
        &--m-t {
            margin-top: 20px;
        }

        &--m-b {
            margin-bottom: 20px;
        }
    }

    &__key-specification-wrapper {
        margin: 30px 0 0 0;
    }

    &__key-specification {
        display: flex;
        flex-direction: column;

        @media screen and (min-width: 350px) {
            display: grid;
            grid-template-columns: repeat(2, minmax(120px, 1fr));
        }

        row-gap: 15px;
        column-gap: 5px;
        padding: 15px;
        background-color: #E5F4FA;
        border-radius: $default-card-border-radius;
        margin-top: 10px;
        margin-bottom: 0;

        &-title {
            display: inline-block;
            font-size: 16px;
            font-weight: 700;
            margin-top: 0;
            margin-bottom: 0;
        }
    }


    &__key-specification-link {
        grid-column: span 2;
    }

    &__model-opening-hours {
        span {
            font-weight: bold;
            color: #FF8500;

        }

        &--is-open {
            span {
                color: #5EB565;
            }
        }

        &--is-closed {
            span {
                color: #FF0000;
            }
        }
    }

    .modal {
        &__content {
            justify-content: flex-start;
        }

        &__body {
            display: block;
        }
    }

    .modal__container {
        max-width: 350px;
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/used-vue/components/VehicleDetails.vue